export default "__VITE_ASSET__0ad9d26a__"